export const CHECKOUT_DETAILS_SHIMMER_ID = 'checkout-details-shimmer';
